import { Link } from "react-router-dom";
import { Phone, ArrowRight, BadgeCheck, Building2, Users, MapPin } from "lucide-react";
import { HeaderLogo } from "@/components/AnimatedLogo";

export const PHONE = "01 48 20 98 27";
export const PHONE_TEL = "+33148209827";

export const SectionTitle = ({ kicker, title }) => (
  <div className="mb-10">
    <p className="text-xs font-semibold tracking-[0.2em] uppercase text-[#F97316]">{kicker}</p>
    <h2 className="mt-2 text-2xl md:text-3xl font-bold text-[#0A1864]">{title}</h2>
  </div>
);

export const ConfianceHero = ({ title = "Pourquoi faire confiance à JyVis Assurances" }) => (
  <header className="bg-[#0A1864] text-white" data-testid="confiance-hero">
    <div className="max-w-6xl mx-auto px-5 pt-5">
      <Link to="/" data-testid="confiance-home-link"><HeaderLogo theme="contact" size="sm" showName={false} dark /></Link>
    </div>
    <div className="max-w-6xl mx-auto px-5 py-16 md:py-24">
      <p className="text-sm font-semibold tracking-[0.2em] uppercase text-white/60">Le courtier des professionnels</p>
      <h1 className="mt-4 text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight max-w-3xl">{title}</h1>
      <p className="mt-6 text-lg md:text-xl text-white/80 italic">« Assurer son quotidien, c'est assurer son avenir »</p>
      <div className="mt-10 flex flex-col sm:flex-row gap-3">
        <a href={`tel:${PHONE_TEL}`} data-testid="confiance-call-btn"
          className="inline-flex items-center justify-center gap-2 rounded-full bg-white text-[#0A1864] px-7 py-4 font-semibold hover:bg-slate-100 transition-colors">
          <Phone className="w-5 h-5" /> <span className="hidden sm:inline">Appeler un conseiller · </span><span className="sm:hidden">Appeler ·</span> <span className="whitespace-nowrap">{PHONE}</span>
        </a>
        <Link to="/devis/rc-decennale" data-testid="confiance-quote-btn"
          className="inline-flex items-center justify-center gap-2 rounded-full bg-[#F97316] text-white px-7 py-4 font-semibold hover:bg-[#ea6a0c] transition-colors">
          Obtenir mon devis <ArrowRight className="w-5 h-5" />
        </Link>
      </div>
    </div>
  </header>
);

const GUARANTEES = [
  { icon: BadgeCheck, title: "Courtier ORIAS n° 26005663", text: "Immatriculation vérifiable sur orias.fr", href: "https://www.orias.fr", id: "orias" },
  { icon: Building2, title: "LS ASSUR", text: "RCS Paris 993 855 527", id: "rcs" },
  { icon: Users, title: "Plus de 1 000 clients", text: "Particuliers, artisans et entreprises", id: "clients" },
  { icon: MapPin, title: "Île-de-France et Guadeloupe", text: "Deux territoires, un même accompagnement", id: "zones" },
];

export const Guarantees = () => (
  <section className="max-w-6xl mx-auto px-5 py-16 md:py-20" data-testid="confiance-guarantees">
    <SectionTitle kicker="Nos garanties" title="Un courtier enregistré et contrôlé" />
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {GUARANTEES.map(({ icon: Icon, title, text, href, id }) => {
        const body = (
          <>
            <Icon className="w-7 h-7 text-[#0A1864]" />
            <p className="mt-4 font-bold text-[#0A1864]">{title}</p>
            <p className="mt-1 text-sm text-slate-600">{text}</p>
          </>
        );
        const cls = "block rounded-2xl border border-slate-200 p-6 bg-white hover:border-[#0A1864] transition-colors";
        return href
          ? <a key={id} href={href} target="_blank" rel="noopener noreferrer" className={cls} data-testid={`guarantee-${id}`}>{body}</a>
          : <div key={id} className={cls} data-testid={`guarantee-${id}`}>{body}</div>;
      })}
    </div>
  </section>
);
